import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class HttpService extends HttpClient {

    getJson<TResult>(url: string): Observable<HttpResponse<TResult>> {
        return this.get<TResult>(url, {observe: 'response', headers: this.createHeaders()});
    }

    postJson<TResult>(url: string, body: Object): Observable<HttpResponse<TResult>> {
        return this.post<TResult>(url, JSON.stringify(body), {observe: 'response', headers: this.createHeaders()});
    }

    private createHeaders(): HttpHeaders {
        return new HttpHeaders().set('Content-Type', 'application/json');
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/http.service.ts